<template>
  <form
    class="grid grid-cols-2 gap-4 overflow-hidden rounded-lg p-1 sm:grid-cols-4"
    @submit="onSubmit"
  >
    <input class="hidden" type="password" />
    <FormInputPassword
      name="pin"
      type="pin"
      label="Supervisor Pin"
      class=""
      :maxlength="4"
    />

    <div
      class="col-start-2 flex items-end justify-end sm:col-start-4"
    >
      <FormSubmitButton :is-disabled="!values.pin">
        Save
      </FormSubmitButton>
    </div>
    <template v-if="isSubmitting">
      <div class="bg-background-fg/8 absolute inset-0">
      </div>
    </template>
  </form>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

const vatFormSchema = z.object({
  pin: z.string().min(0).max(4).regex(/\d+/),
})

const { handleSubmit, values } = useForm({
  validationSchema: toTypedSchema(vatFormSchema),
  initialValues: { pin: "" },
})

const isSubmitting = ref(false)
const onSubmit = handleSubmit(async (params) => {
  isSubmitting.value = true
  try {
    await updateSupervisorPin(params)
    toast.success("Supervisor PIN changed")
  } catch (error) {
    toast.error("Failed to change supervisor pin")
    logError(error)
  } finally {
    isSubmitting.value = false
  }
})
</script>
